﻿import { IgnoreChanges } from '../decorators/change-tracker';
import { Enumerable } from '../decorators/enumerable';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eFeatureCenter } from '../enums';
import { IWeldVerticesFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { eMeshChangeTypes, Feature } from './feature';

@Kb3dModel({
    token: Token.WeldVerticesFeature,
})
export class WeldVerticesFeature extends Feature implements IWeldVerticesFeature {
    static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affectedBy = new Set([eMeshChangeTypes.VertexPositions, eMeshChangeTypes.VertexIndices]);
    static _affects = new Set([
        eMeshChangeTypes.VertexPositions,
        eMeshChangeTypes.VertexIndices,
        eMeshChangeTypes.VertexUvs,
        eMeshChangeTypes.VertexNormals,
        eMeshChangeTypes.Submeshes,
    ]);

    translation: KbVector;
    rotationAngle: number;
    _previewParticleSize: number;
    rotationAxis: KbVector;
    scale: KbVector;
    center: eFeatureCenter;

    @IgnoreChanges
    private _vertexIndices: number[];
    @Enumerable()
    public get vertexIndices(): number[] {
        if (!this._vertexIndices) this._vertexIndices = [];
        return this._vertexIndices;
    }
    public set vertexIndices(val) {
        this._vertexIndices = val;
    }
}
